import React from 'react';
import { contactInfo } from '../mock';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-[hsl(var(--bg-light))]">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <span className="caption mb-4 block">
            Get In Touch
          </span>
          <h2 className="heading-2 mb-6">
            Contact Us
          </h2>
          <p className="body-medium max-w-3xl mx-auto">
            We're here to assist you with all your accounting and financial needs.
          </p>
        </div>

        {/* Contact Information - Centered */}
        <div className="max-w-2xl mx-auto">
          <div className="space-y-6 mb-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[hsl(var(--primary-blue)/.1)] rounded-lg flex items-center justify-center flex-shrink-0">
                <MapPin className="text-[hsl(var(--primary-blue))]" size={24} />
              </div>
              <div>
                <p className="body-small font-semibold text-[hsl(var(--text-primary))] mb-1">Address</p>
                <a
                  href="https://maps.app.goo.gl/NpRL47ce6GkNuV5K9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="body-small text-[hsl(var(--text-secondary))] hover:text-[hsl(var(--primary-blue))] transition-colors"
                >
                  {contactInfo.address}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[hsl(var(--primary-blue)/.1)] rounded-lg flex items-center justify-center flex-shrink-0">
                <Phone className="text-[hsl(var(--primary-blue))]" size={24} />
              </div>
              <div>
                <p className="body-small font-semibold text-[hsl(var(--text-primary))] mb-1">Phone</p>
                <p className="body-small text-[hsl(var(--text-secondary))]">{contactInfo.phone}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[hsl(var(--primary-blue)/.1)] rounded-lg flex items-center justify-center flex-shrink-0">
                <Mail className="text-[hsl(var(--primary-blue))]" size={24} />
              </div>
              <div>
                <p className="body-small font-semibold text-[hsl(var(--text-primary))] mb-1">Email</p>
                <p className="body-small text-[hsl(var(--text-secondary))]">{contactInfo.email}</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[hsl(var(--primary-blue)/.1)] rounded-lg flex items-center justify-center flex-shrink-0">
                <Clock className="text-[hsl(var(--primary-blue))]" size={24} />
              </div>
              <div>
                <p className="body-small font-semibold text-[hsl(var(--text-primary))] mb-1">Business Hours</p>
                <p className="body-small text-[hsl(var(--text-secondary))]">{contactInfo.hours}</p>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="bg-white p-6 rounded-lg border border-[hsl(var(--border-light))] shadow-sm">
            <p className="body-small text-[hsl(var(--text-secondary))] leading-relaxed text-center">
              Whether you need assistance with taxation, audit services, or business advisory, 
              our team of experienced professionals is ready to help you navigate your financial challenges.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
